import { render, staticRenderFns } from "./ModelOfDelivery.vue?vue&type=template&id=646ea37a&"
import script from "./ModelOfDelivery.vue?vue&type=script&lang=js&"
export * from "./ModelOfDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports